"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.split.js");

/*
 * 单位处理，主要是针对商业的钱做分转元，元转分处理
 * 精度
 */
var Money = {
  /**
   * @function Money[toYuan] - 分转元
   * @param {string | number} [num=0] 分
   * @example
   * import { Money } from '@zz-biz/utils';
   * 
   * Money.toYuan(1);
   * 
   * // return 100
   * @return {number} num / 100 带两位小数的浮点型
   */
  toYuan: function toYuan() {
    var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var digit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    if (isNaN(parseFloat(num))) return 0; //不是数字的返回0

    var m = Math.pow(10, digit);
    return parseFloat((Math.round(parseFloat(num) * 0.01 * m, 10) / m).toFixed(2));
  },

  /**
   * @function Money[toFen] - 元转分
   * @param {string | number} [num=0] 元
   * @example
   * import { Money } from '@zz-biz/utils';
   * 
   * Money.toFen(0.29);
   * 
   * // return 29
   * @return {number} num * 100
   */
  toFen: function toFen() {
    var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (isNaN(parseFloat(num))) return 0;
    var yuanStr = num.toString();

    if (yuanStr.match(/^[-+]?\d*$/)) {
      yuanStr += '.00';
    } else if (yuanStr.match(/^[-+]?\d*\.\d$/)) {
      yuanStr += '0';
    }

    return parseFloat(yuanStr.replace(/^([-+]?)(\d*)\.(\d{2})\d*$/, '$1$2$3'));
  },

  /**
   * @function Money[format] - 格式化钱，每三位加','，eg：16,666.00
   * @param {string | number} num
   * @return {string} 处理后结果
   * @example
   * import { Money } from '@zz-biz/utils';
   * 
   * Money.format(2353323443.01);
   * 
   * // 2,353,323,443.01
   */
  format: function format() {
    var money = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!money || money === '0') return '0';
    if (typeof money === 'number') money = String(money);
    var arr = money.split('.');

    if (arr && arr.length) {
      var temp = arr[1] ? ".".concat(arr[1]) : '.00';

      for (var i = arr[0].length - 1, j = 1; i >= 0; i--, j++) {
        temp = arr[0].charAt(i) + temp;

        if (j % 3 === 0 && i !== 0) {
          temp = ',' + temp;
        }
      }

      return temp;
    }

    return money;
  }
};
var _default = Money;
exports["default"] = _default;